function a(t) {
  return t.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function u(t) {
  return t.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function i(t, n = !0) {
  t = u(t);
  const r = n && /^\s*-/.test(t), e = t.split(".", 1)[0].replace(/[^\d]/g, "");
  return e ? (r ? "-" : "") + e.replace(/^0+(?=\d)/, "") : r ? "-" : "";
}
function o(t) {
  var e;
  if (t == null || t === "") return "";
  const n = typeof t == "number" ? String(t) : t.trim(), r = /^(-?)(\d+)(\.\d+)?$/.exec(n);
  return r ? r[1] + a(r[2]) + ((e = r[3]) != null ? e : "") : n;
}
function c(t) {
  const n = i(t);
  if (n === "" || n === "-") return;
  const r = Number(n);
  return Number.isFinite(r) ? r : void 0;
}
function s(t) {
  return t.toLocaleString("ja-JP");
}
function f(t) {
  return t == null ? "—" : t.toLocaleString("ja-JP");
}
function l(t) {
  return t == null ? "" : t.toLocaleString("ja-JP");
}
function m(t) {
  return `${t < 0 ? "-" : ""}¥${Math.abs(t).toLocaleString("ja-JP")}`;
}
function g(t) {
  return t ? t.slice(0, 16).replace("T", " ") : "—";
}
export {
  i as a,
  c as b,
  g as c,
  s as d,
  l as e,
  o as f,
  f as g,
  m as h,
  u as t
};
